import { renderNumber, parseNumToPercentage } from './number';

export function readableTime(ms: number) {
  if (typeof ms !== 'number' || ms < 0) return '0s';

  const units = [
    { label: 'd', ms: 86400000 },
    { label: 'h', ms: 3600000 },
    { label: 'm', ms: 60000 },
    { label: 's', ms: 1000 },
  ];

  const parts: any[] = [];

  for (const unit of units) {
    const count = Math.floor(ms / unit.ms);
    if (count > 0) {
      parts.push(`${count}${unit.label}`);
      ms %= unit.ms;
    }
    if (parts.length === 2) break;
  }

  if (parts.length === 0) return '0s';

  return parts.join(' ');
}

export const formatter = {
  '#': renderNumber,
  '%': parseNumToPercentage,
  ms: readableTime,
};
